import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaKey } from "react-icons/fa";
import { Translate } from "react-redux-i18n";
import MiniLoader from "./MiniLoader";
import "./styles/PasswordForgetForm.css";

class PasswordForgetForm extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    if (!this.props.submitDisabled && this.props.onSubmit) {
      this.props.onSubmit(e);
    }
  };

  render() {
    const { email, touched, submitDisabled, loading, onChange, onBlur } = this.props;
    const showError = touched && submitDisabled && email.length > 0;

    return (
      <div className="password-forget-page">
        <div className="password-forget-card">
          <div className="password-forget-card__icon" aria-hidden="true">
            <FaKey />
          </div>

          <header className="password-forget-card__header">
            <h1 className="password-forget-card__title">
              <Translate value="password_forget_title" />
            </h1>
            <p className="password-forget-card__subtitle">
              <Translate value="password_forget_tip" />
            </p>
          </header>

          <form className="password-forget-form" onSubmit={this.handleSubmit} noValidate>
            <label className="password-forget-form__label" htmlFor="recovery_email">
              <Translate value="profile_email" />
            </label>
            <div className="password-forget-form__input-wrap">
              <span className="password-forget-form__input-icon" aria-hidden="true">
                <FaEnvelope />
              </span>
              <input
                id="recovery_email"
                type="email"
                name="email"
                className={`password-forget-form__input${
                  showError ? " password-forget-form__input--invalid" : ""
                }`}
                placeholder="email@ejemplo.com"
                value={email}
                onChange={onChange}
                onBlur={onBlur}
                autoComplete="email"
                required
              />
            </div>
            {showError && (
              <p className="password-forget-form__error">
                <Translate value="warning_email_valid" />
              </p>
            )}

            <button
              type="submit"
              className="password-forget-form__submit"
              disabled={submitDisabled || loading}
            >
              {loading ? <MiniLoader /> : <Translate value="password_forget_send" />}
            </button>
          </form>

          <div className="password-forget-card__links">
            <p>
              <Translate value="password_forget_login" />{" "}
              <Link to="/login">
                <Translate value="login" />
              </Link>
            </p>
            <p>
              <Translate value="password_forget_register" />{" "}
              <Link to="/register">
                <Translate value="register" />
              </Link>
            </p>
          </div>

          <p className="password-forget-card__support">
            <Translate value="password_forget_email" />{" "}
            <a href="mailto:team@godiway.com?subject=Godiwayer">
              team@godiway.com
            </a>
          </p>
        </div>
      </div>
    );
  }
}

export default PasswordForgetForm;
